import { makeStyles, Button } from '@material-ui/core';
import React, { useState, useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import BackForwardButton from '../../Shared/BackForwardButton';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import OrderDetailProgressBar from '../../Order/OrderDetail/OrderDetailProgressBar';
import OrderDetailMainInfo from '../../Order/OrderDetail/OrderDetailMainInfo';
import OrderDetailMaterials from '../../Order/OrderDetail/OrderDetailMaterials';
import OrderDetailStatusBar from '../../Order/OrderDetail/OrderDetailStatus/OrderDetailStatusBar';
import { NavLink } from "react-router-dom";
import { dataService } from '../../../Services/data.service'
import { useTranslation } from 'react-i18next';
import FlagstoneTheme from '../../../Config/flagstoneTheme';
import MachineParametersDrawer from '../../MachineParameters/MachineParametersDrawer';
import ManualReplenishmentDrawer from '../../ManualReplenishment/ManualReplenishmentDrawer';
import OrderDetailStateDrawer from '../../Order/OrderDetail/OrderDetailStatus/OrderDetailStateDrawer';
import { toast } from 'react-toastify';
import MaterialCorrectionDrawer from '../../ManualReplenishment/MaterialCorrectionDrawer';
import DeleteDialog from '../../Shared/Dialogs/DeleteDialog';
import ScissorStateComponent from '../../Workstation/ScissorStateComponent';
import { scissorTypes } from '../../../Config/scissorStates'
import { productionOrderStates } from '../../../Config/productionOrderStates'
import { machineScissorZone, productTypeRawMaterial, productTypeAdditive } from '../../../Config/constants'
import AlertDialog from '../../Shared/Dialogs/AlertDialog';
import { connect } from 'react-redux';
import { ControlPointSharp } from '@material-ui/icons';
import TransportOrdersDrawer from '../../TransportOrder/TransportOrdersDrawer';

export const OrderDetailPage = (props) => {
    const classes = useStyles();

    const [order, setOrder] = useState(null);
    const [nextOrder, setNextOrder] = useState(null);
    const [previousOrder, setPreviousOrder] = useState(null);
    const [orderDetailStateDrawerOpen, setOrderDetailStateDrawerOpen] = useState(false);
    const [machineParametersDrawerOpen, setMachineParametersDrawerOpen] = useState(false);
    const [manualReplenishmentDrawerOpen, setManualReplenishmentDrawerOpen] = useState(false);
    const [materialCorrectionDrawerOpen, setMaterialCorrectionDrawerOpen] = useState(false);
    const [replenishAlertDialogOpen, setReplenishAlertDialogOpen] = useState(false)
    const [deleteOrderFromZoneDialogOpen, setDeleteOrderFromZoneDialogOpen] = useState(false)
    const [deleteQuantitiesDialogOpen, setDeleteQuantitiesDialogOpen] = useState(false)
    const [dialogTitle, setDialogTitle] = useState(null)
    const [dialogContext, setDialogContext] = useState(null)
    const [updateQuantityAtMachine, setUpdateQuantityAtMachine] = useState(false)
    const [quantitiesAssigned, setQuantitiesAssigned] = useState([])
    const [quantityIdToRemove, setQuantityIdToRemove] = useState(null)
    const [orderToRemoveFromZone, setOrderToRemoveFromZone] = useState(null)
    const [orderRefresh, setOrderRefresh] = useState(false)
    const [producedBOMOut, setProducedBOMOut] = useState(null)
    const [zones, setZones] = useState([])
    const [transportOrdersDrawerOpen, setTransportOrdersDrawerOpen] = useState(false);

    const { t } = useTranslation();
    let historyLocation = useLocation();
    let history = useHistory();
    useEffect(() => {
        dataService.getOrderDetailsByOrderId(parseInt(props.match.params.id)).then(productionOrder => {
            if (JSON.stringify(productionOrder) !== JSON.stringify(order)) {
                setOrder(productionOrder);

                dataService.getMachinesByMachineType(machineScissorZone).then(scissorZones => {
                    if (JSON.stringify(zones) !== JSON.stringify(scissorZones)) {
                        setZones(scissorZones);
                    }
                }).catch((error) => { toast.error(error, { position: toast.POSITION.TOP_CENTER }) });
            }
            dataService.getProductionOrdersByMachine(props.workstation.selectedWorkstation).then(orders => {
                if (productionOrder.productionOrderStatus !== productionOrderStates.STOPPED && productionOrder.productionOrderStatus !== productionOrderStates.DONE) {
                    //SC: First collect all running/paused orders and add these togheter.
                    let runningOrders = orders.filter(x => x.productionOrderStatus === productionOrderStates.RUNNING || x.productionOrderStatus === productionOrderStates.PAUSED).sort((a,b) => {
                        return new Date(b.startedOn).getTime() - 
                            new Date(a.startedOn).getTime()
                    });

                    //SC: Now make a list with all planned orders
                    let plannedOrders = orders.filter(x => x.productionOrderStatus === productionOrderStates.PLANNED).sort((a,b) => {
                        return new Date(b.startedOn).getTime() - 
                            new Date(a.startedOn).getTime()
                    });
                    
                    //SC: Combine the running orders and planned orders togheter.
                    orders = [...runningOrders, ...plannedOrders];
                }
                else {
                    orders = orders.filter(x => x.productionOrderStatus === productionOrderStates.STOPPED || x.productionOrderStatus === productionOrderStates.DONE).sort((a,b) => {
                        return new Date(a.finishedOn).getTime() - 
                            new Date(b.finishedOn).getTime()
                    });;
                    console.log('orders ', orders)              

                }

                let index = orders.findIndex(x => x.id === productionOrder.id)
                if (index + 1 >= orders.length) {
                    //SC: No next order available
                    setNextOrder(null);
                }
                else {
                    //SC: Set next order
                    setNextOrder(orders[index + 1]);
                }

                if (index - 1 < 0) {
                    //SC: No previous order available
                    setPreviousOrder(null);
                }
                else {
                    //SC: Set previous order
                    setPreviousOrder(orders[index - 1]);
                }

            }).catch((error) => { toast.error(error, { position: toast.POSITION.TOP_CENTER }) })

            dataService.getMachineInAssignedByMachineId(productionOrder.machineIdPlanned).then(assigned => {

                if (JSON.stringify(assigned) !== JSON.stringify(quantitiesAssigned)) {
                    setQuantitiesAssigned(assigned)
                }

            }).catch((error) => { toast.error(error, { position: toast.POSITION.TOP_CENTER }) })

            dataService.getProductionOrderLineBOMOutProducedByBOMOutId(productionOrder.bomOut[0].id).then(bomOutProduced => {

                if (JSON.stringify(bomOutProduced) !== JSON.stringify(producedBOMOut)) {
                    setProducedBOMOut(bomOutProduced)
                }

            }).catch((error) => { toast.error(error, { position: toast.POSITION.TOP_CENTER }) })

        }).catch((error) => { toast.error(error, { position: toast.POSITION.TOP_CENTER }) })


    }, [updateQuantityAtMachine, orderRefresh,props.workstationState])

    const selectLine = (line, orderId) => {
        dataService.getProductionOrdersByMachine(line).then(orders => {
            if (historyLocation.pathname.includes("/order/") || historyLocation.pathname.includes("/qualitychecks/")) {
                let firstOrder = orders.find(x => x.productionOrderStatus === productionOrderStates.RUNNING)
                if (!firstOrder) {
                    firstOrder = orders.find(x => x.productionOrderStatus === productionOrderStates.PAUSED)
                    if (!firstOrder) {
                        firstOrder = orders.find(x => x.productionOrderStatus === productionOrderStates.PLANNED)
                        if (!firstOrder) {
                            firstOrder = orders.find(x => x.productionOrderStatus === productionOrderStates.STOPPED)
                            if (!firstOrder) {
                                firstOrder = orders.find(x => x.productionOrderStatus === productionOrderStates.DONE)
                            }
                        }
                    }
                }

                if (firstOrder) {
                    if (historyLocation.pathname.includes("/order/")) {
                        history.push('/order/' + firstOrder.id);
                    }
                    else {
                        history.push('/qualitychecks/' + firstOrder.id);
                    }
                }

                if (orderId) {
                    history.push('/order/' + orderId);
                }
            }

            orders = orders.filter(o => o.productionOrderStatus === productionOrderStates.PLANNED || o.productionOrderStatus === productionOrderStates.PAUSED || o.productionOrderStatus === productionOrderStates.RUNNING)
            var o;
            var ordersOnZones = false;
            for (o = 0; o < orders.length; o++) {
                if (orders[o].bowMetaData) {

                    let bowMetaData = JSON.parse(orders[o].bowMetaData)
                    let metaData = bowMetaData.find(x => x.MetaDataType === 1).MetaData[0]

                    if (metaData.UsedZones.length > 0 && !ordersOnZones) {
                        ordersOnZones = true
                        props.actions.setSelectedZone(zones.find(x => x.id === metaData.UsedZones[0].ZoneId).name)
                        props.actions.setSelectedWorkstation(line)
                    }
                }
            }

            if (!ordersOnZones) {
                props.actions.setSelectedZone(null)
                props.actions.setSelectedWorkstation(line)
            }

        }).catch((error) => { toast.error(error, { position: toast.POSITION.TOP_CENTER }) })
    }

    const openMachineParametersDrawer = (open) => {
        setMachineParametersDrawerOpen(open);
    }

    const openOrderDetailStateDrawer = (open) => {
        setOrderDetailStateDrawerOpen(open);
    }

    const openManualReplenishmentDrawer = (open) => {
        setManualReplenishmentDrawerOpen(open);
    }

    const openMaterialCorrectionDrawer = (open) => {
        setMaterialCorrectionDrawerOpen(open);
    }

    const updateOrderDetailPage = () => {
        setOrderRefresh(!orderRefresh)
    }

    function replenishMaterial(quantity, id, silo, purchaseOrderNumber) {
        dataService.assignQuantityAtMachine(order.machineIdPlanned, id, quantity, silo, purchaseOrderNumber).then(setUpdateQuantityAtMachine(true)).catch((error) => { toast.error(error, { position: toast.POSITION.TOP_CENTER }) })
        setUpdateQuantityAtMachine(!updateQuantityAtMachine)
        refreshQuantitiesAssigned()
    }

    const openDeleteQuantitiesDialog = (id) => {
        setQuantityIdToRemove(id)
        setDialogTitle("Delete")
        setDialogContext("Are you sure deleting this quantity?")
        setDeleteQuantitiesDialogOpen(true)
    }

    const openDeleteOrderFromZoneDialog = (zone, scissor, orderRef, orderId) => {
        let scissorPosition = ""
        if (scissor === 1) {
            scissorPosition = "upper"
        }
        else {
            scissorPosition = "lower"
        }
        setOrderToRemoveFromZone({ zone: zone, scissor: scissor, orderId: orderId })
        setDialogTitle("Delete")
        setDialogContext(t("Are you sure deleting order ") + orderRef + t(" from zone ") + zone + t(" on the ") + t(scissorPosition) + t(" scissor?"))
        setDeleteOrderFromZoneDialogOpen(true)
    }

    const deleteMaterialAssigned = (id) => {
        dataService.deleteMachineInAssignedById(id).then(
            setUpdateQuantityAtMachine(!updateQuantityAtMachine),

            refreshQuantitiesAssigned()
        ).catch((error) => { toast.error(error, { position: toast.POSITION.TOP_CENTER }) })
        setDeleteQuantitiesDialogOpen(false)
    }

    const removeOrderFromZone = (object) => {
        let orderId = object.orderId;
        let scissor = object.scissor;
        let zone = object.zone;

        dataService.getOrderDetailsByOrderId(orderId).then(productionOrder => {

            let scissorPosition = scissorTypes.UPPER;
            if (scissor === 0) {
                scissorPosition = scissorTypes.LOWER;
            }
            let allZones = zones.filter(x => x.code.includes(scissorPosition));
            let bowMetaData = JSON.parse(productionOrder.bowMetaData)

            let indexOfZone = bowMetaData.find(x => x.MetaDataType === 1).MetaData[0].UsedZones.findIndex(x => x.ZoneId === allZones.find(y => y.name === zone).id)
            bowMetaData.find(x => x.MetaDataType === 1).MetaData[0].UsedZones.splice(indexOfZone, 1)
            if (bowMetaData.find(x => x.MetaDataType === 1).MetaData[0].UsedZones.length === 0) {
                if (productionOrder.productionOrderStatus === productionOrderStates.RUNNING) {
                    dataService.stopProductionOrder(orderId).then().catch((error) => { toast.error(error, { position: toast.POSITION.TOP_CENTER }) })
                }
                dataService.updateZones(null, orderId, productionOrder.machineIdPlanned).then().catch((error) => { toast.error(error, { position: toast.POSITION.TOP_CENTER }) })
            }
            else {
                dataService.updateZones(JSON.stringify(bowMetaData), orderId, productionOrder.machineIdPlanned).then().catch((error) => { toast.error(error, { position: toast.POSITION.TOP_CENTER }) })
            }

            setDeleteOrderFromZoneDialogOpen(false)

            setOrderRefresh(!orderRefresh)
            selectLine(productionOrder.machineIdPlanned, orderId)

        }).catch((error) => { toast.error(error, { position: toast.POSITION.TOP_CENTER }) })
    }

    const removeAllOrdersFromAllZones = (zoneArray) => {
        var zonesByOrderArray = []
        var i;
        for (i = 0; i < zoneArray.length; i++) {
            if (zonesByOrderArray.some(x => x.some(y => y.orderId === zoneArray[i].orderId))) {
                var index = zonesByOrderArray.findIndex(z => z.find(x => x.orderId === zoneArray[i].orderId))
                zonesByOrderArray[index].push(zoneArray[i])
            }
            else {
                zonesByOrderArray.push([zoneArray[i]])
            }
        }

        var y;
        for (y = 0; y < zonesByOrderArray.length; y++) {
            var orderId = zonesByOrderArray[y][0].orderId

            dataService.getOrderDetailsByOrderId(orderId).then(productionOrder => {
                let bowMetaData = JSON.parse(productionOrder.bowMetaData)
                var index = zonesByOrderArray.findIndex(z => z.find(x => x.orderId === productionOrder.id))
                var z;
                for (z = 0; z < zonesByOrderArray[index].length; z++) {

                    let scissor = zonesByOrderArray[index][z].scissor
                    let scissorPosition = scissorTypes.UPPER;
                    if (scissor === 0) {
                        scissorPosition = scissorTypes.LOWER;
                    }
                    let allZones = zones.filter(x => x.code.includes(scissorPosition));

                    let indexOfZone = bowMetaData.find(x => x.MetaDataType === 1).MetaData[0].UsedZones.findIndex(x => x.ZoneId === allZones.find(y => y.name === zonesByOrderArray[index][z].zone).id)

                    bowMetaData.find(x => x.MetaDataType === 1).MetaData[0].UsedZones.splice(indexOfZone, 1)
                }

                if (bowMetaData.find(x => x.MetaDataType === 1).MetaData[0].UsedZones.length === 0) {
                    dataService.updateZones(null, productionOrder.id, productionOrder.machineIdPlanned).then().catch((error) => { toast.error(error, { position: toast.POSITION.TOP_CENTER }) })
                }
                else {
                    dataService.updateZones(JSON.stringify(bowMetaData), productionOrder.id, productionOrder.machineIdPlanned).then().catch((error) => { toast.error(error, { position: toast.POSITION.TOP_CENTER }) })
                }

                setOrderRefresh(!orderRefresh)
                selectLine(productionOrder.machineIdPlanned, orderId)

            }).catch((error) => { toast.error(error, { position: toast.POSITION.TOP_CENTER }) })
        }
    }

    const checkQuantitiesAtMachineBeforeBookingOrStarting = () => {

        if (getLackingMaterials().length > 0) {

            setDialogTitle("Replenish Materials!")
            setDialogContext("Attention! Materials need to be replenished! Click +ADD MATERIAL.")
            setReplenishAlertDialogOpen(true)
            return false;
        }

        return true
    }

    const getLackingMaterials = () => {
        let lackingMaterials = []
        var i;
        let totalPallets = Math.ceil(order.bomOut[0].quantityToProduce / order.bomOut[0].quantityOnCarrier)

        let bomInNoPackaging = order.bomIn.filter(x => {
            let metaData = JSON.parse(x.bomMetaData)
            return metaData.find(y => y.MetaDataType === 1).MetaData[0].ProductType === productTypeAdditive || metaData.find(y => y.MetaDataType === 1).MetaData[0].ProductType === productTypeRawMaterial
        })


        for (i = 0; i < bomInNoPackaging.length; i++) {

            let minimumNeededQuantity = bomInNoPackaging[i].quantityToConsume / totalPallets

            if (parseFloat(getQuantityAtMachine(bomInNoPackaging[i].productId).toFixed(3)) < parseFloat(minimumNeededQuantity.toFixed(3))) {
                lackingMaterials.push(bomInNoPackaging[i].productId)
            }
        }


        return lackingMaterials
    }

    const refreshQuantitiesAssigned = () => {
        dataService.getMachineInAssignedByMachineId(order.machineIdPlanned).then(assigned => {

            if (JSON.stringify(assigned) !== JSON.stringify(quantitiesAssigned)) {
                setQuantitiesAssigned(assigned)
            }

        }).catch((error) => { toast.error(error, { position: toast.POSITION.TOP_CENTER }) })
    }

    const openTransportOrdersDrawer = (open) => {
        setTransportOrdersDrawerOpen(open);
    }

    const getQuantityAtMachine = (productId) => {
        let quantityAtMachine = 0;
        var i;
        for (i = 0; i < quantitiesAssigned.length; i++) {
            if (JSON.parse(quantitiesAssigned[i].metaData).find(x => x.MetaDataType === 1).MetaData[0].ProductId === productId) {
                quantityAtMachine += quantitiesAssigned[i].quantityAssigned
            }
        }

        return quantityAtMachine;
    }

    const navigateToNextOrder = () => {

        if (nextOrder) {

            if (nextOrder.bowMetaData) {
                let metaData = JSON.parse(nextOrder.bowMetaData).find(x => x.MetaDataType === 1).MetaData[0]

                if (metaData.UsedZones.length > 0) {
                    props.actions.setSelectedZone(zones.find(x => x.id === metaData.UsedZones[0].ZoneId).name)
                }
            }
            else {
                props.actions.setSelectedZone(null)
            }

            history.push('/order/' + nextOrder.id);

        } else {
            if (order) {
                history.push('/order/' + order.id);
            }
        }
    }

    const navigateToPreviousOrder = () => {

        if (previousOrder) {

            if (previousOrder.bowMetaData) {
                let metaData = JSON.parse(previousOrder.bowMetaData).find(x => x.MetaDataType === 1).MetaData[0]

                if (metaData.UsedZones.length > 0) {
                    props.actions.setSelectedZone(zones.find(x => x.id === metaData.UsedZones[0].ZoneId).name)
                }
            }
            else {
                props.actions.setSelectedZone(null)
            }

            history.push('/order/' + previousOrder.id);

        } else {
            if (order) {
                history.push('/order/' + order.id);
            }
        }
    }

    return (
        <div className={classes.background}>
            {order ? <React.Fragment>
                <div className={classes.main}>
                    <div className={classes.header}>
                        <div className={classes.title}>
                            <NavLink className={classes.navButton} to={`/workstation`}>
                                <BackForwardButton direction={'Back'} textOverride={t("Back to production queue")}></BackForwardButton>
                            </NavLink>
                            <div className={classes.orderNumber}>
                                {"Order " + order.reference}
                            </div>
                        </div>
                        {props.workstationState.workstationsWithScissorStatusInfo ?
                            <div className={classes.scissorStatus}>
                                <div className={classes.upperScissor}>
                                    <ScissorStateComponent size={"L"} machineNumber={order.machinePlannedCode.match(/\d/g).join("")} scissorStatus={props.workstationState.workstationsWithScissorStatusInfo.find(x => x.id === props.workstation.selectedWorkstation).scissorStatuses.find(x => x.scissorName === scissorTypes.UPPER)}></ScissorStateComponent>
                                </div>
                                <div className={classes.lowerScissor}>
                                    <ScissorStateComponent size={"L"} machineNumber={order.machinePlannedCode.match(/\d/g).join("")} scissorStatus={props.workstationState.workstationsWithScissorStatusInfo.find(x => x.id === props.workstation.selectedWorkstation).scissorStatuses.find(x => x.scissorName === scissorTypes.LOWER)}></ScissorStateComponent>
                                </div>
                            </div> : <React.Fragment></React.Fragment>}
                    </div>
                    <div className={classes.body}>
                        <div className={classes.upperBody}>
                            <div className={classes.progress}>
                                <div className={classes.productionProgress}>
                                    {t('Production progress (n° of palets)')}
                                </div>
                                <OrderDetailProgressBar producedBOMOut={producedBOMOut} productionOrder={order} {...props}></OrderDetailProgressBar>
                            </div>
                            <div className={classes.upNext}>
                                <div className={classes.upNextHeader}>
                                    <div className={classes.titleUpNext}>
                                        {t('UpNext')}:
                                        
                                    </div>

                                    <div className={classes.buttonContainer}>
                                    {previousOrder !== null &&
                                        <div className={classes.viewPreviousButton}>
                                           
                                            <Button onClick={() => navigateToPreviousOrder()}>
                                            <ArrowBackIosIcon className={classes.arrowForward}></ArrowBackIosIcon>
                                                <div className={classes.viewDetails}>
                                                    {t('Previous')}
                                                </div>
                                            </Button>
                                        </div>
                                    }
                                    {nextOrder !== null &&
                                        <div className={classes.viewDetailsButton}>
                                           
                                            <Button onClick={() => navigateToNextOrder()}>
                                                <div className={classes.viewDetails}>
                                                    {t('Next')}
                                                </div>
                                                <ArrowForwardIosIcon className={classes.arrowForward}></ArrowForwardIosIcon>
                                            </Button>
                                        </div>
                                    }
                                    </div>
                                    
                                </div>
                                <div className={classes.timeNextOrder}>
                                    <div className={classes.timeSvg}><svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15" className="__web-inspector-hide-shortcut__"><defs></defs><path className="a" fill="#8d8d8d" fillRule="evenodd" d="M2.2,2.2A7.224,7.224,0,0,1,7.5,0a7.224,7.224,0,0,1,5.3,2.2A7.224,7.224,0,0,1,15,7.5a7.224,7.224,0,0,1-2.2,5.3A7.224,7.224,0,0,1,7.5,15a7.224,7.224,0,0,1-5.3-2.2A7.224,7.224,0,0,1,0,7.5,7.224,7.224,0,0,1,2.2,2.2Zm5.97.479h-.8V7.366H4.018v.8H8.17Z" /></svg></div>
                                    <div className={classes.time}>
                                        {nextOrder ? nextOrder.reference : ''}
                                    </div>
                                </div>
                                <div className={classes.gradientSplitter}>
                                </div>
                                <div className={classes.nextOrderCode}>
                                    {nextOrder ? nextOrder.customerName : ''}
                                </div>
                            </div>
                        </div>

                        <div className={classes.middleBody}>
                            <OrderDetailMainInfo productionOrder={order} {...props}></OrderDetailMainInfo>
                        </div>

                        <div className={classes.lowerBody}>
                            <OrderDetailMaterials openManualReplenishmentDrawer={openManualReplenishmentDrawer} openMaterialCorrectionDrawer={openMaterialCorrectionDrawer} setUpdateQuantityAtMachine={setUpdateQuantityAtMachine} updateQuantityAtMachine={updateQuantityAtMachine} productionOrder={order} getQuantityAtMachine={getQuantityAtMachine} {...props}></OrderDetailMaterials>
                        </div>
                    </div>
                </div>
                <div className={classes.sideBar}>
                    <OrderDetailStatusBar openTransportOrdersDrawer={openTransportOrdersDrawer} refreshOrder={updateOrderDetailPage} producedBOMOut={producedBOMOut} productionOrder={order} checkQuantitiesAtMachineBeforeBookingOrStarting={checkQuantitiesAtMachineBeforeBookingOrStarting} openOrderDetailStateDrawer={openOrderDetailStateDrawer} {...props} actions={props.actions} openMachineParametersDrawer={openMachineParametersDrawer} quantitiesAssigned={quantitiesAssigned}></OrderDetailStatusBar>
                </div>
                <TransportOrdersDrawer openDrawer={openTransportOrdersDrawer} drawerOpen={transportOrdersDrawerOpen} {...props}></TransportOrdersDrawer>
                <OrderDetailStateDrawer orderRefresh={orderRefresh} removeOrderFromZone={removeOrderFromZone} removeAllOrdersFromAllZones={removeAllOrdersFromAllZones} refreshOrder={updateOrderDetailPage} openDeleteOrderFromZoneDialog={openDeleteOrderFromZoneDialog} openDrawer={openOrderDetailStateDrawer} drawerOpen={orderDetailStateDrawerOpen} {...props} actions={props.actions} productionOrder={order} selectLine={selectLine} checkQuantitiesAtMachineBeforeBookingOrStarting={checkQuantitiesAtMachineBeforeBookingOrStarting}></OrderDetailStateDrawer>
                <MachineParametersDrawer openDrawer={openMachineParametersDrawer} drawerOpen={machineParametersDrawerOpen} productionOrder={order} {...props}></MachineParametersDrawer>
                <MaterialCorrectionDrawer opendrawer={openMaterialCorrectionDrawer} draweropen={materialCorrectionDrawerOpen} quantitiesAssigned={quantitiesAssigned} productionOrder={order} openDeleteQuantitiesDialog={openDeleteQuantitiesDialog}></MaterialCorrectionDrawer>
                <DeleteDialog dialogOpen={deleteOrderFromZoneDialogOpen} dialogTitle={dialogTitle} dialogContext={dialogContext} closeDialog={() => setDeleteOrderFromZoneDialogOpen(false)} action={() => removeOrderFromZone(orderToRemoveFromZone)}></DeleteDialog>
                <DeleteDialog dialogOpen={deleteQuantitiesDialogOpen} dialogTitle={dialogTitle} dialogContext={dialogContext} closeDialog={() => setDeleteQuantitiesDialogOpen(false)} action={() => deleteMaterialAssigned(quantityIdToRemove)}></DeleteDialog>
                <AlertDialog dialogOpen={replenishAlertDialogOpen} dialogTitle={dialogTitle} dialogContext={dialogContext} closeDialog={() => setReplenishAlertDialogOpen(false)} action={() => setReplenishAlertDialogOpen(false)}></AlertDialog>
                <ManualReplenishmentDrawer opendrawer={openManualReplenishmentDrawer} draweropen={manualReplenishmentDrawerOpen} actions={props.actions} productionOrder={order} {...props} replenishmaterial={replenishMaterial}></ManualReplenishmentDrawer>
            </React.Fragment> : <React.Fragment></React.Fragment>}
        </div>
    )
}

const useStyles = makeStyles({
    header: {
        height: '100px',
        marginTop: "20px"
    },
    title: {
        width: "50%",
        float: "left",
        height: "80px"
    },
    scissorStatus: {
        width: "50%",
        float: "left",
        height: "80px",
        boxSizing: 'border-box',
        paddingRight: "2.4%",
        marginTop: "2px"
    },
    upperScissor: {
        width: "100%",
        height: "40px"
    },
    lowerScissor: {
        width: "100%",
        height: "40px"
    },
    body: {
        height: "100px"
    },
    orderNumber: {
        fontSize: "32px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'Medium',
        color: "#000000",
        marginTop: "5px"
    },
    background: {
        padding: "1.6%",
        paddingRight: "0px",
        paddingTop: "0px",
        position: "relative",
        top: "40px"
    },
    sideBar: {
        width: "20%",
        float: "left",
        background: "linear-gradient(white, transparent);",
        height: "95%"
    },
    main: {
        width: "80%",
        float: "left"
    },
    upperBody: {
        display: "block",
        height: "100px"
    },
    middleBody: {
        display: "block",
        backgroundColor: "white",
        height: "auto",
        borderRadius: "6px",
        boxShadow: "0px 3px 15px rgba(0,0,0,0.1)",
        marginTop: "10px",
        width: "97.7%",
        marginRight: "0.7%"
    },
    lowerBody: {
        display: "block",
        backgroundColor: "white",
        height: "auto",
        borderRadius: "6px",
        boxShadow: "0px 3px 15px rgba(0,0,0,0.1)",
        marginTop: "10px",
        width: "97.7%",
        marginRight: "0.7%"
    },
    progress: {
        height: "100px",
        width: "60%",
        backgroundColor: "white",
        boxShadow: "0px 3px 15px rgba(0,0,0,0.1)",
        borderRadius: "6px",
        float: "left",
        boxSizing: "border-box",
        marginRight: "0.7%",
        padding: "10px"
    },
    upNext: {
        display: "flex",
        flexDirection: "column",
        height: "100px",
        width: "37%",
        border: "1px solid #DEDEDE",
        borderRadius: "6px",
        float: "left",
        boxSizing: "border-box",
        marginRight: "0.7%",
        padding: "0px 10px"
    },
    productionProgress: {
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'bold',
        color: "#020100",
        display: "block",
        width: "100%",
        marginLeft: "3%",
        marginTop: "10px"

    },
    viewDetails: {
        float: "left",
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'Medium',
        color: FlagstoneTheme.palette.primary.main,
        textTransform: "none",
        marginRight: "5px"
    },
    arrowForward: {
        color: FlagstoneTheme.palette.primary.main,
        width: "15px",
        height: "15px",
        float: "left"
    },
    titleUpNext: {
        //paddingTop: '5px',
        float: "left",
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'bold',
        color: "#020100",
        marginTop: '5px',

    },
    buttonContainer: {
        display: "flex",
        float: "right"

    },
    viewPreviousButton: {
        //float: "left"
    },
    viewDetailsButton: {
        //float: "right"
    },
    upNextHeader: {
        display: 'block',
        height: "20px"
    },
    timeNextOrder: {
        marginTop: '9px',
        display: 'flex',
        height: "30px",
        alignItems: "center",
    },
    timeSvg: {
        float: "left",
        marginRight: "5px"

    },
    time: {
        float: "left",
        fontSize: "22px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'medium',
        color: "#020100",
    },
    gradientSplitter: {
        display: 'block',
        width: "100%",
        height: "7px",
        background: " transparent linear-gradient(90deg, #DEDEDE 0%, #F1F1F1 100%) 0% 0% no-repeat padding-box;",
        marginTop: "3px",
        borderRadius: "5px"
    },
    nextOrderCode: {
        display: 'block',
        fontSize: "13px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'medium',
        color: "#8D8D8D",
        marginTop: '3px'
    },



});

function mapStateToProps(state) {
    return {
        workstationState: state.workstationState
    }
}

export default connect(mapStateToProps)(OrderDetailPage)